import { IEntity } from './engine';

export * from './model';
export * from './engine';
export * from './kissbot-event';
export * from './kissbot-event-data-types';
export * from './socket/kissbot-socket';
export * from './socket/kissbot-socket-message-types';

export const convertParameterNameToEntityWithNameAndType = (value: string): IEntity => {
    const values = value.split('__xx__');
    let type = values[0];
    if (type.startsWith('sys')) {
        type = type.replace('_', '.');
    }
    type = '@' + type
    return <IEntity>{ type: type, name: values[1] };
}

export const convertNameAndTypeToParameterName = (type: string, name: string): string => {
    if (type.indexOf('@sys') > -1) {
        type = type.replace('.', '_');
        type = type.replace('@', '');
    } else if (type.indexOf('') > -1) {
        type = type.replace('@', '');
    }
    return type + '__xx__' + name;
}

export const convertPhoneNumber = (phone: string) => {
    phone = phone.replace(/\D/g, '');

    if (!phone.startsWith('55') || phone.length === 13) {
        return phone;
    }

    if (phone.length === 12) {
        if (Number(phone.slice(4, 5)) <= 7) {
            return phone;
        } else {
            return phone.split('').map((k, i) => i === 4 ? `9${k}` : k).join('');
        }
    }

    return phone;
}

export const getNumberWithout9 = (number: string) => {
    if (number.length == 13 && number.startsWith('55')) {
        const firstPart = number.slice(0, 4);
        const secondPart = number.slice(5);
        return firstPart + secondPart;
    }
    return number;
}

export const getNumberWith9 = (number: string) => {
    if (number.length == 12 && number.startsWith('55')) {
        if (number.startsWith('55800')) {
            return number;
        }
        return number.slice(0,4) + '9' + number.slice(-8);
    }
    return number;
}

export const getWithAndWithout9PhoneNumber = (phoneNumber: string) => {
    //Se for brasil faz essa validação de retornar com ou sem o 9, pois podemos ter com ou sem o 9 em vários lugares
    if(phoneNumber.startsWith('55')) {
        let option1 = phoneNumber;
        let option2
        if (phoneNumber.length == 13) {
            option2 = getNumberWithout9(phoneNumber);
        } else if (phoneNumber.length == 12) {
            option2 = getNumberWith9(phoneNumber);
        }
        return [option1, option2]
    }
    return [phoneNumber]
}


export const getTopicPrefix = (topicName: string) => {
    // if(process.env.NODE_ENV == 'local') {
    //     return `qlqttpwa-_${topicName}`
    // }
    return `${process.env.NODE_ENV}_${topicName}`
}